import React, {forwardRef} from 'react';
import PrivadoMappingForm from './PrivadoMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';

function PrivadoCredentialsForm(props, ref){
    const fields = [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator],
        },
        {
            name: "customerId",
            label: "Customer ID",
            required: true
        },
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ]
    return(
        <GenericPullCredentialsForm
        {...props}
        ref={ref}
        fields={fields}
        MappingForm={PrivadoMappingForm}
        initialValue={{apiEndpoint:"https://api.code.privado.ai/prod"}}
        />
    )
};

export default forwardRef(PrivadoCredentialsForm)